import React, {
  createContext,
  useContext,
  useState,
  type ReactNode,
} from "react";

interface AgoraContextType {
  showPollResultModal: boolean;
  setShowPollResultModal: React.Dispatch<React.SetStateAction<boolean>>;
  pollData: any;
  setPollData: React.Dispatch<React.SetStateAction<any>>;
}

const AgoraContext = createContext<AgoraContextType | undefined>(undefined);

interface AgoraProviderProps {
  children: ReactNode;
}

export const AgoraProvider: React.FC<AgoraProviderProps> = ({ children }) => {
  const [showPollResultModal, setShowPollResultModal] =
    useState<boolean>(false);
  const [pollData, setPollData] = useState<any>(null);

  return (
    <AgoraContext.Provider
      value={{
        showPollResultModal,
        setShowPollResultModal,
        pollData: pollData,
        setPollData: setPollData,
      }}
    >
      {children}
    </AgoraContext.Provider>
  );
};

export const useAgoraContext = (): AgoraContextType => {
  const context = useContext(AgoraContext);

  if (!context) {
    throw new Error("useAgoraContext must be used within AgoraProvider");
  }

  return context;
};
